import * as React from 'react';

import {Modal} from 'shells/modal/modal';
import {LeftFrame, RightFrame} from 'shells/modal/step-modal/layout';
import {StepList} from 'shells/modal/step-modal/step-list';

import {useGetCompetitorIqWebsites, useShowGetStarted} from '../graphql/hooks';

import {AddCompetitors} from './add-competitors';
import {ConfirmWebsite} from './confirm-website';
import {ReviewSetup} from './review-setup';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

const STEPS = ['1. Confirm your website', '2. Add some competitors', '3. Review setup'];

export function CompetitorIqOnboardingModal(props: Props) {
    const {isOpen, onClose} = props;
    const [activeStepIndex, setActiveStepIndex] = React.useState<number>(0);
    const [website, setWebsite] = React.useState<string>('');
    const [competitors, setCompetitors] = React.useState<string[]>([]);

    const {
        predictedWebsite: savedPredictedWebsite,
        website: previouslySavedWebsite,
        competitors: savedCompetitors,
    } = useGetCompetitorIqWebsites();

    const {onHideGetStarted} = useShowGetStarted();

    React.useEffect(() => {
        if (savedPredictedWebsite) {
            setWebsite(savedPredictedWebsite);
        }

        if (previouslySavedWebsite) {
            setWebsite(previouslySavedWebsite);
        }

        if (savedCompetitors.length) {
            setCompetitors(savedCompetitors);
        }
    }, [savedPredictedWebsite, previouslySavedWebsite, savedCompetitors]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            canClickOutsideToClose={false}
            canEscapeToClose={false}
            maxHeight={600}
            noPadding={true}
        >
            <div className='flex full-height'>
                <LeftFrame title='Get started with competitor tracking'>
                    <StepList activeStepIndex={activeStepIndex} steps={STEPS} />
                </LeftFrame>
                <RightFrame>
                    {activeStepIndex === 0 && (
                        <ConfirmWebsite
                            // @ts-expect-error
                            location={location}
                            website={website}
                            onSaveWebsite={(savedWebsite) => {
                                setWebsite(savedWebsite);
                                setActiveStepIndex(1);
                            }}
                        />
                    )}
                    {activeStepIndex === 1 && (
                        <AddCompetitors
                            // @ts-expect-error
                            location={location}
                            competitors={competitors}
                            onBack={() => setActiveStepIndex(0)}
                            onNext={() => setActiveStepIndex(2)}
                        />
                    )}
                    {activeStepIndex === 2 && (
                        <ReviewSetup
                            website={website}
                            competitors={competitors}
                            onBack={() => setActiveStepIndex(1)}
                            onStartTracking={() => {
                                if (onHideGetStarted) {
                                    onHideGetStarted();
                                }

                                onClose();
                            }}
                        />
                    )}
                </RightFrame>
            </div>
        </Modal>
    );
}
